import React, { useState, useEffect } from "react";
import { Box, TextField, Button, Typography, Table, TableHead, TableBody, TableRow, TableCell,
    Paper, TableContainer, IconButton, Tooltip} from "@mui/material";
import axiosInstancePromise from './axiosConfig';
// import EditIcon from '@mui/icons-material/Edit';
import RestoreIcon from '@mui/icons-material/SettingsBackupRestore';
import BackupIcon from '@mui/icons-material/CloudDownload';
import BtnEliminar from '../componentes/botones/Delete'
import { styleTableCell, styleTableCell2 } from "../estilo/Main"
import ConfirmModal from "../componentes/modales/ConfirmModal";

const SuperUserCreateClient = () => {
    const [nombre, setNombre] = useState("");
    const [subdominio, setSubdominio] = useState("");
    const [email, setEmail] = useState("");
    const [nickname, setNickname] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [message, setMessage] = useState("");
    const [datos, setData] = useState([]);
    const [columns, setColumns] = useState([]);
    const [editingClient, setEditingClient] = useState(null);
    const [openConfirmModal, setOpenConfirmModal] = useState(false);
    const [confirmAction, setConfirmAction] = useState(() => () => {});
    const [confirmTitle, setconfirmTitle] = useState("");

    const openModalWithAction = (action, title) => {
        setConfirmAction(() => action);
        setconfirmTitle(title);
        setOpenConfirmModal(true);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (password !== confirmPassword) {
            setMessage("Las contraseñas no coinciden");
            return;
        }
        try {
            const axiosInstance = await axiosInstancePromise;
            const endpoint = editingClient ? `/editar-cliente` : "/superus-crear-cliente";
            
            const response = await axiosInstance.post(endpoint, {
                nombre,
                email,
                subdominio,
                nickname,
                password
            });
            
            setMessage(response.data.message);
            limpiarFormulario();
            fetchData();

        } catch (error) {
            setMessage("Error: " + error.response?.data?.error);
        }
    };

    const limpiarFormulario = () => {
        setNombre("");
        setEmail("");
        setSubdominio("");
        setNickname("");
        setPassword("");
        setConfirmPassword("");
        setEditingClient(null);
    };

    const handleEdit = (cliente) => {
        setNombre(cliente.nombre);
        setEmail(cliente.email);
        setSubdominio(cliente.subdominio);
        setNickname(cliente.nickname);
        setEditingClient(cliente);
    };



    const handleRestore = async (dbname) => {
        try {
            const axiosInstance = await axiosInstancePromise;
            await axiosInstance.post(`/restaurar-cliente`, { db_name: dbname});
            setMessage("Cliente restaurado correctamente");
        } catch (error) {
            setMessage("Error al restaurar: " + error.response?.data?.error);
        }
    };

    const handleBackup = async (subdominio) => {
        try {
            const axiosInstance = await axiosInstancePromise;
            const response = await axiosInstance.get(`/backup-cliente`, { params: {subdominio: subdominio},responseType: 'blob' });
            
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `backup_${subdominio}.sql`);
            document.body.appendChild(link);
            link.click();
        } catch (error) {
            setMessage("Error al hacer backup: " + error.response?.data?.error);
        }
    };

    const fetchData = async () => {
        try {
            const axiosInstance = await axiosInstancePromise;
            const response = await axiosInstance.get(`/get-clientes`);
            setColumns(response.data.columns || []);
            setData(response.data.rows || []);
        } catch (error) {
            console.error("Error al obtener los clientes:", error.response?.data || error.message);
        }
    };
    
    useEffect(() => {
        fetchData();
    }, []);

    useEffect(() => {
        if (message !== '') {
            const timer = setTimeout(() => {
                setMessage('');
            }, 3500);
            return () => clearTimeout(timer);
        }
    }, [message]);

    return (
        <>
            <Box sx={{ width: 400, mx: "auto", mt: 4, p: 3, boxShadow: 3, borderRadius: 2 }}>
                <Typography variant="h6">{editingClient ? "Editar Cliente" : "Nuevo Cliente"}</Typography>
                <TextField fullWidth label="Nombre" value={nombre} onChange={(e) => setNombre(e.target.value)} margin="normal" />
                <TextField fullWidth label="Correo" value={email} onChange={(e) => setEmail(e.target.value)} margin="normal" />
                <TextField fullWidth label="Subdominio" value={subdominio} onChange={(e) => setSubdominio(e.target.value)} margin="normal" />
                <TextField fullWidth label="Nickname" value={nickname} onChange={(e) => setNickname(e.target.value)} margin="normal" />
                <TextField fullWidth label="Contraseña" type="password" value={password} onChange={(e) => setPassword(e.target.value)} margin="normal" />
                <TextField fullWidth label="Confirmar Contraseña" type="password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} margin="normal" />
                <Button fullWidth variant="contained" color="primary" onClick={handleSubmit}>
                    {editingClient ? "Actualizar Cliente" : "Crear Cliente"}
                </Button>
                <Button fullWidth variant="outlined" color="secondary" onClick={limpiarFormulario} sx={{ mt: 1 }}>Limpiar</Button>
                {message && <Typography color="secondary" mt={2}>{message}</Typography>}
            </Box>
            
            <TableContainer component={Paper} sx={{ mt: 3, mx: "auto", width: "90%" }}>
                <Table>
                    <TableHead>
                        <TableRow>
                            {columns.map((column) => <TableCell key={column} sx={styleTableCell}>{column}</TableCell>)}
                            <TableCell sx={styleTableCell} >Acciones</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {datos.map((row) => (
                            <TableRow key={row.id}>
                                {columns.map((col) => 
                                <TableCell key={col}  sx={styleTableCell2} > {row[col]} </TableCell>)}
                                <TableCell sx={styleTableCell2} >
                                    <BtnEliminar table={'superus'} rowid={row.id} rowdb={row.db_name} funcSenal={fetchData} />
                                    <Tooltip title="Restaurar" arrow>
                                    <IconButton onClick={() =>
                                        openModalWithAction(() => handleRestore(row.db_name), `¿Restaurar la base de datos de ${row.db_name}?`)
                                        }><RestoreIcon /></IconButton>
                                    </Tooltip>    
                                    <Tooltip title="Crear respaldo" arrow>
                                    <IconButton onClick={() =>
                                        openModalWithAction(() => handleBackup(row.db_name), `¿Quieres hacer un respaldo de ${row.db_name}?`)
                                        }><BackupIcon /></IconButton>
                                    </Tooltip>    

                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <ConfirmModal
                open={openConfirmModal}
                onClose={() => setOpenConfirmModal(false)}
                onConfirm={() => {
                    confirmAction();
                    setOpenConfirmModal(false);
                }}
                title={confirmTitle}
            />
        </>
    );
};

export default SuperUserCreateClient;
